import { Box, Button, Center, Container, Divider, Group, SegmentedControl, Switch, Text, Title, useMantineColorScheme, useMantineTheme } from '@mantine/core';
import { IconMoon, IconSun } from '@tabler/icons-react';
import { FormInputWrapper } from 'core/components/';
import { useDispatch, useSelector } from 'react-redux';
import { setKeywordHighlighting } from './settingsSlice';

const SettingsModule = () => {
    const theme = useMantineTheme();
    const dispatch = useDispatch();
    const keywordHighlighting = useSelector(state => state.settingsReducer.keywordHighlighting ?? true);
    const clearCache = () => {
        const ignoreKeys = ['onset_public_token', 'user'];
        // we want to clear the persist data all local storage keys that start with persist:
        const persistKeys = Object.keys(localStorage);
        persistKeys.filter(key => !ignoreKeys.includes(key)).forEach(key => {
            localStorage.removeItem(key);
        });
        // clear the app state
        // reload the window
        window.location.reload();
    }
    return (
        <Box
            id='settingsModule'
            sx={(theme) => ({
                // backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.white,
                width: '100%',
            })}>
            <Container mt={'xl'}>
                <Box px='lg'>
                    <Group
                        className='main-container-header'
                        justify='space-between'
                        sx={({
                            borderBottom: `1px solid`,
                            borderColor: theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[2],
                            backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.white,
                        })}>
                        {/* <Crumbline></Crumbline> */}
                        <Box>
                            <Title order={3}>Workspace Settings</Title>
                            <Text size={'sm'}>Manage your workspace</Text>
                        </Box>
                    </Group>

                    <Group className='container-action-bar' sx={{ width: '100%' }} position='apart' height={'100%'} py='xs' mt='sm'>
                        <Box style={{ width: '100%' }}>
                            <Group justify='apart'>
                                <Title className='main-content-heading' order={5} mb='xs'>
                                    Notifications
                                </Title>
                            </Group>

                            <FormInputWrapper labelWidth={200} label='Enable browser notifications' id='input-notifications'>
                                <Group justify='right' sx={{ margin: 0 }}>
                                    <Switch defaultChecked></Switch>
                                </Group>
                            </FormInputWrapper>

                            <Divider />

                            <Group justify='apart' mt={'xl'}>
                                <Title className='main-content-heading' order={5} mb='xs'>
                                    Search
                                </Title>
                            </Group>

                            <FormInputWrapper labelWidth={200} label='Enable keyword highlighting' id='input-keyword-highlighting'>
                                <Group justify='right' sx={{ margin: 0 }}>
                                    <Switch 
                                        checked={keywordHighlighting}
                                        onChange={(e) => dispatch(setKeywordHighlighting(e.currentTarget.checked))}
                                    />
                                </Group>
                            </FormInputWrapper>

                            <Divider />

                            <Group justify='apart' mt={'xl'}>
                                <Title className='main-content-heading' order={5} mb='xs'>
                                    Theme
                                </Title>
                            </Group>

                            <FormInputWrapper labelWidth={'auto'} label='Set the theme for your workspace' id='input-notifications'>
                                <Group justify='flex-end' style={{ marginTop: -40 }}>
                                    <SegmentedToggle />
                                </Group>
                            </FormInputWrapper>


                            <Divider />

                            <Group justify='apart' mt={'xl'}>
                                <Title className='main-content-heading' order={5} mb='xs'>
                                    OnSet Cache
                                </Title>
                            </Group>

                            <FormInputWrapper labelWidth={'auto'} label='Clear the cache for OnSet workspace' id='input-notifications'>
                                <Group justify='flex-end' style={{ marginTop: 0 }}>
                                    <Button onClick={() => clearCache()} variant='default'>Clear Cache</Button>
                                </Group>
                            </FormInputWrapper>

                            <Text c='dimmed' pt={13} size={'xs'}>
                                OnSet v0.2.11
                            </Text>
                        </Box>
                    </Group>
                </Box>
            </Container>
        </Box>
    );
};

export default SettingsModule;

const SegmentedToggle = () => {
    const { colorScheme, toggleColorScheme } = useMantineColorScheme();

    return (
        <Group position='center' my='xl'>
            <SegmentedControl
                value={colorScheme}
                onChange={(value) => toggleColorScheme(value)}
                data={[
                    {
                        value: 'light',
                        label: (
                            <Center>
                                <IconSun size={16} stroke={1.5} />
                                <Box ml={10}>Light</Box>
                            </Center>
                        ),
                    },
                    {
                        value: 'dark',
                        label: (
                            <Center>
                                <IconMoon size={16} stroke={1.5} />
                                <Box ml={10}>Dark</Box>
                            </Center>
                        ),
                    },
                ]}
            />
        </Group>
    );
};
